<template>
    <div>
        <Banner/>
        <!--充电运营管理服务系统-->
        <div class="charge">
            <div class="charge_img">
                <img src="@/asstes/solution/first.png" style="width: 100%;">
            </div>
            <div class="charge_info">
                <div class="charge_info_title">充电运营管理服务系统</div>
                <div class="charge_info_pgh">
                    社区充电、露营、集体充电<br/>
                    <br/>
                    基于当前互联网信息技术，建立一套完善的多方协调沟通机制，为新能源汽车用户提供一站式服务，节省用户及车企人员大量时间与精力，实现充电桩安装、运营、售后、共享可视化管理，整合资源、信息共通，形成高效率、快执行的加速发展格局，对促进电动汽车产业化发展以及能源环境保护,都有着十分重要的现实意义。</div>
<!--                <div class="charge_info_more" @click="chargeMore">了解更多</div>-->
            </div>
            <div class="charge_pc">
                <img src="@/asstes/solution/first_dec.png">
            </div>

        </div>

        <div class="infoList">
            <div class="infoList_title">① 私桩安装运维服务平台系统</div>
            <div class="infoList_pgh">
                根据新能源汽车主机厂用户建桩需求，车桩分离，车主从电子商城等购买专用充电桩；搭建建桩服务流程体系，为各类用户提供多元化
                的充电解决方案，解决建桩流程困惑，售后过程不透明，用户服务信息统计困难，资源协调线下管理内部流程管控标准不统一，服务效率
                和品质难以保障等挑战，从而实现用户服务水平提升和用户极致体验的提高。
            </div>
            <div class="infoList_subtitle">
                主要功能：电子商城、销售平台、车主APP、订单管理、结算管理、售后运营、物料数据、充电管理
            </div>
            <div class="infoList_title">② 私桩共享运营服务平台系统</div>
            <div class="infoList_pgh">
                不仅为新能源车主带来了更便利的充电选择，还可以实现电网资源的优化配置，提升充电配套利用率，进一步推动纯电绿色出行的加速普及。
            </div>
            <div class="infoList_subtitle">
                主要功能：系统管理、客户管理、财务管理、订单管理、运营商管理、充电管理
            </div>
            <div class="infoList_title">③ 目的地充电平台系统</div>
            <div class="infoList_pgh">
                针对目的地充电需求，搭建可视化、一体化充电平台，为园区、政府、地产等客户提供技术保障，实现精细化和智能化管理。
            </div>
            <div class="infoList_subtitle">
                主要功能：桩管理、电站管理、客户管理、营销运营管理、财务管理
            </div>
        </div>
    </div>
</template>

<script>
    import Banner from './banner'
    export default {
        components: {
            Banner
        },
    }
</script>

<style lang="less" scoped>

    @media only screen and (max-width: 750px){
        .charge{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            text-align: center;
            padding:  216px 144px 0 144px;
            box-sizing: border-box;

            .charge_img{
                width: 100%;
                img{
                    width: 100%;
                }
            }
            .charge_info{
                padding-top: 180px;
                box-sizing: border-box;

                .charge_info_title{
                    font-weight: 600;
                    color: #373A5A;
                    font-size: 79.2px;
                    padding-bottom: 86.4px;
                    box-sizing: border-box;
                }
                .charge_info_pgh{
                    text-align: left;
                    font-size: 50.4px;
                    line-height: 90px;
                    padding-bottom: 72px;
                    box-sizing: border-box;
                }
                .charge_info_more{
                    text-align: left;
                    font-weight: 500;
                    color: #07CFA2;
                    font-size: 43.2px;
                    line-height: 57.6px;
                }
            }
            .charge_pc{
                display: none;
            }
        }

        .infoList{
            padding: 0 144px;
            box-sizing: border-box;
            font-size: 50.8px;
            .infoList_title{
                font-weight: 600;
                padding-bottom: 48px;
                box-sizing: border-box;
            }
            .infoList_pgh{
                font-weight: 400;
                line-height: 86.4px;
                padding-bottom: 120px;
                box-sizing: border-box;
            }
            .infoList_subtitle{
                color: #07CFA2;
                padding-bottom: 160px;
                box-sizing: border-box;
            }
        }
    }

    @media only screen and (min-width: 750px) {
        .charge{
            padding: 64px 120px;
            box-sizing: border-box;
            display: flex;
            justify-content: center;
            align-items: flex-end;

            .charge_img{
                padding-right: 80px;
                box-sizing: border-box;
            }

            .charge_info{
                color: #373A5A;
                padding-right: 24px;
                box-sizing: border-box;

                .charge_info_title{
                    font-size: 36px;
                    font-weight: 600;
                    color: #373A5A;
                    line-height: 50px;
                    padding-bottom: 32px;
                    box-sizing: border-box;
                }
                .charge_info_subtitle, .charge_info_pgh{
                    max-width: 380px;
                    font-weight: 400;
                    color: #000000;
                    line-height: 32px;
                }
                .charge_info_subtitle{
                    font-size: 15px;
                    padding-bottom: 16px;
                    box-sizing: border-box;
                }
                .charge_info_pgh{
                    font-size: 12px;
                    padding-bottom: 10px;
                    box-sizing: border-box;
                }
                .charge_info_more{
                    color: #07CFA2;
                    font-size: 10px;
                }
                .charge_info_more:hover{
                    cursor: pointer;
                }
            }

            .charge_pc{
                img{
                    width: 100%;
                }
            }
        }

        .infoList{
            color: #000;
            padding: 24px 120px;
            box-sizing: border-box;

            .infoList_title{
                font-size: 20px;
                padding-bottom: 32px;
                font-weight: 600;
            }

            .infoList_pgh{
                font-size: 15px;
                line-height: 28px;
                padding-bottom: 40px;
                box-sizing: border-box;
            }

            .infoList_subtitle{
                font-size: 15px;
                color: #07CFA2;
                padding-bottom: 48px;
                box-sizing: border-box;
            }
        }
    }
</style>